// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"ecfa452c","533":"b5d02bbe","540":"7a2b93ea","687":"dcbe834b","702":"c8e7fb16"}[chunkId] + ".chunk.js";
};